<template>
  <span>
    <span v-for="item in searchdt_term" :key="item.value" class="input_radio_wrap">
      <label>
        <input
          type="radio"
          v-model="s_cntchargterm"
          :value="item.value"
          @change="doClick(item)"
          />
          {{ item.text }}
      </label>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    fr: { type: String, required: true },
    to: { type: String, required: true },
  },
  watch: {
    'fr' : 'autoSelect',
    'to' : 'autoSelect',
  },
  data() {
    return {
      s_cntchargterm: "",
      searchdt_term : [
        { value : 'now', text : '당일'  , dt : T.doSetSearchDt('now') },
        { value : '1m' , text : '1개월' , dt : T.doSetSearchDt('1m')  },
        { value : '6m' , text : '6개월' , dt : T.doSetSearchDt('6m')  },
        { value : '1y' , text : '1년'   , dt : T.doSetSearchDt('1y')  },
      ],
      today: T.now('YYYY-MM-DD'),
      sendEmit : 0, // 내 자신이 바꾼것은 watch를 피하기 위한 변수 ( 무한루프 방지 )
    }
  },
  mounted() {
    this.autoSelect()
  },
  methods: {
    doClick(item) {
      this.sendEmit = 0
      if (this.fr != item.dt   ) { this.$emit("update:fr", item.dt)   ; this.sendEmit++ } // 다를때만 emit
      if (this.to != this.today) { this.$emit("update:to", this.today); this.sendEmit++ } // 다를때만 emit
    },
    autoSelect() { // from to 변경시 자동선택
      // console.log("call")
      if (this.sendEmit > 0) {
        this.sendEmit--
        return
      }
      // console.log("FR ", this.fr, ", TO ", this.to)

      // to 조건 확인. 틀리면 no match
      if (this.to != this.today) return this.s_cntchargterm = "no_match"

      // fr 조건 확인. 내부 배열 확인
      const item = this.searchdt_term.find(item=>item.dt == this.fr) // 사용자가 입력한 fr 이 배열에 있나 ?
      if (item) return this.s_cntchargterm = item.value // 있으면 그걸로
      this.s_cntchargterm = "no_match" // 없으면 no_match ( 모든 라디오 박스 선택 해제됨. )

    },
  },
}
</script>